import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "PatientInfo__Main" }
const _hoisted_2 = { class: "header-row align-items-center fw-bold" }
const _hoisted_3 = { class: "header-cell fw-bold user-name font-size-xl me-2" }
const _hoisted_4 = { class: "header-cell fw-bold mt-sm-1 user-mrn" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 mr-1" }, "MRN:", -1 /* HOISTED */)
const _hoisted_6 = { class: "header-row fw-bold font-size-xs" }
const _hoisted_7 = { class: "header-cell" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-default"
}
const _hoisted_10 = { class: "header-cell" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "badge CodeStatus__Red",
  tooltip: "title: Do Not Resuscitate"
}
const _hoisted_13 = {
  key: 1,
  class: "badge CodeStatus__Green"
}
const _hoisted_14 = {
  key: 0,
  class: "header-cell"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning-status-label bg-warning-status rounded risk-label" }, "Fall Risk", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "header-cell"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning-status-label bg-warning-status rounded risk-label" }, "Hospitalization Risk", -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "header-cell"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-warning-status-label bg-warning-status rounded risk-label" }, "Infection Risk", -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 3,
  class: "header-cell"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "header-row fw-bold font-size-xs" }
const _hoisted_28 = { class: "header-cell" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt me-1 text-app-secondary-hh" }, null, -1 /* HOISTED */)
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 1,
  class: "text-default"
}
const _hoisted_32 = { class: "header-cell" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-birthday-cake me -1 text-app-secondary-hh",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "text-default"
}
const _hoisted_37 = { class: "header-cell" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-mobile text-app-secondary-hh me-1",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 1,
  class: "text-default"
}
const _hoisted_42 = { class: "header-cell" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle header-divider" }, null, -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-phone-square me-1 text-app-secondary-hh`)
}, null, -1 /* HOISTED */)
const _hoisted_45 = ["href"]
const _hoisted_46 = {
  key: 1,
  class: "text-default"
}
const _hoisted_47 = { class: "header-row font-size-xs" }
const _hoisted_48 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_49 = { class: "information-cell" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Episode", -1 /* HOISTED */)
const _hoisted_51 = { class: "information-cell" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Insurance Name/ID", -1 /* HOISTED */)
const _hoisted_53 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_54 = { class: "information-cell" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Start of Care Date", -1 /* HOISTED */)
const _hoisted_56 = { class: "information-cell" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Primary Contact", -1 /* HOISTED */)
const _hoisted_58 = ["href"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "information-column d-flex flex-column me-4" }
const _hoisted_61 = { class: "information-cell" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Attending Physician", -1 /* HOISTED */)
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "information-cell" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("b", { class: "title" }, "Secondary Contact", -1 /* HOISTED */)
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["href"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-default" }, "Not Available", -1 /* HOISTED */)
const _hoisted_71 = [
  _hoisted_70
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePatientNameClick()))
        }, _toDisplayString(_ctx.selectedPatientDetails.DisplayNameWithMi), 1 /* TEXT */)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.selectedPatientDetails.PatientIdNumber), 1 /* TEXT */)
      ])), [
        [_directive_tooltip, { title: 'Medical Record Number (MRN)' }]
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
        (_ctx.selectedPatientDetails.Gender)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.selectedPatientDetails.Gender), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "No Gender Selected"))
      ])), [
        [_directive_tooltip, { title: 'Sex' }]
      ]),
      _createElementVNode("span", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, [
          (_ctx.selectedPatientDetails.IsDNR)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "DNR"))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, " Full Code "))
        ])
      ]),
      (_ctx.patientRiskDetails?.IsSelectedFallsRiskAssessment)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
        : _createCommentVNode("v-if", true),
      (_ctx.patientRiskDetails?.IsSelectedHighRiskForHospitalization)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
        : _createCommentVNode("v-if", true),
      (_ctx.patientRiskDetails?.IsSelectedHighRiskForInfection)
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
        : _createCommentVNode("v-if", true),
      (_ctx.patientTags.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
            _hoisted_24,
            _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_26)), [
              [_directive_tooltip, { title: `${_ctx.patientTags}` }]
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", _hoisted_27, [
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_28, [
        _hoisted_29,
        (_ctx.hasAddress)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.patientAddressLink,
              target: "_blank"
            }, _toDisplayString(_ctx.address), 9 /* TEXT, PROPS */, _hoisted_30))
          : (_openBlock(), _createElementBlock("span", _hoisted_31, "Address Not Available"))
      ])), [
        [_directive_tooltip, { title: `Patient's Address` }]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_32, [
        _hoisted_33,
        _hoisted_34,
        (_ctx.dobString)
          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.dobString), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_36, "DOB not available"))
      ])), [
        [_directive_tooltip, { title: `Patient's DOB & Age` }]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_37, [
        _hoisted_38,
        _hoisted_39,
        (_ctx.selectedPatientDetails.PhoneHomeFormatted)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `tel: ${_ctx.selectedPatientDetails.PhoneHomeFormatted}`
            }, _toDisplayString(_ctx.selectedPatientDetails.PhoneHomeFormatted), 9 /* TEXT, PROPS */, _hoisted_40))
          : (_openBlock(), _createElementBlock("span", _hoisted_41, "Phone Not Available"))
      ])), [
        [_directive_tooltip, { title: `Patient's Phone Number` }]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_42, [
        _hoisted_43,
        _hoisted_44,
        (_ctx.selectedPatientDetails.PhoneMobileFormatted)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `tel: ${_ctx.selectedPatientDetails.PhoneMobileFormatted}`
            }, _toDisplayString(_ctx.selectedPatientDetails.PhoneMobileFormatted), 9 /* TEXT, PROPS */, _hoisted_45))
          : (_openBlock(), _createElementBlock("span", _hoisted_46, "Phone Not Available"))
      ])), [
        [_directive_tooltip, { title: `Patient's Phone Number` }]
      ])
    ]),
    _createElementVNode("section", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("section", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.patientDetails.CurrentEpisodeDate
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createElementVNode("section", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.selectedPatientDetails.PrimaryInsuranceName
            }, null, 8 /* PROPS */, ["text"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("section", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.selectedPatientDetails.StartOfCareDateFormatted
            }, null, 8 /* PROPS */, ["text"])
          ])
        ]),
        _createElementVNode("section", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: `${_ctx.selectedPatientDetails.EmergencyContact?.FirstName ? _ctx.selectedPatientDetails.EmergencyContact?.FirstName : ''} ${_ctx.selectedPatientDetails.EmergencyContact?.LastName ? _ctx.selectedPatientDetails.EmergencyContact?.LastName : ''}`
            }, null, 8 /* PROPS */, ["text"]),
            (
                                _ctx.selectedPatientDetails.EmergencyContact &&
                                _ctx.selectedPatientDetails.EmergencyContact?.PrimaryPhoneFormatted
                            )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "text-link ms-1",
                  href: `tel:${_ctx.selectedPatientDetails.EmergencyContact?.PrimaryPhoneFormatted})`
                }, _toDisplayString(_ctx.selectedPatientDetails.EmergencyContact.PrimaryPhoneFormatted), 9 /* TEXT, PROPS */, _hoisted_58))
              : (_openBlock(), _createElementBlock("span", _hoisted_59, "Not Available"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("section", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", null, [
            (_ctx.selectedPatientDetails.Physician?.DisplayName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.selectedPatientDetails.Physician?.DisplayName), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_64, "Not Available"))
          ])
        ]),
        _createElementVNode("section", _hoisted_65, [
          _hoisted_66,
          (_ctx.selectedPatientDetails.EmergencyContacts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createVNode(_component_EmptyTextHandler, {
                  text: `${_ctx.selectedPatientDetails.EmergencyContacts[0].FirstName} ${_ctx.selectedPatientDetails.EmergencyContacts[0].LastName}`
                }, null, 8 /* PROPS */, ["text"]),
                (
                                _ctx.selectedPatientDetails.EmergencyContacts &&
                                _ctx.selectedPatientDetails.EmergencyContacts[0].PrimaryPhoneFormatted
                            )
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "text-link ms-1",
                      href: `tel:${_ctx.selectedPatientDetails.EmergencyContacts[0].PrimaryPhoneFormatted})`
                    }, _toDisplayString(_ctx.selectedPatientDetails.EmergencyContacts[0].PrimaryPhoneFormatted), 9 /* TEXT, PROPS */, _hoisted_68))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
        ])
      ])
    ])
  ]))
}